import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, Label } from 'semantic-ui-react';
import { formatCurrencyRupiah } from 'utils/currencyUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import { format } from 'date-fns';

const getStockLabel = product => {
  if (product && product.in_stock === false) {
    return (
      <Label color="red" size="small">
        Out of Stock
      </Label>
    );
  }
  return (
    <Label color="green" size="small">
      In Stock
    </Label>
  );
};

const getDiscountLabel = product => {
  return product.max_allowable_discount_percentage ? (
    <Label color="green" size="small">
      {product.max_allowable_discount_percentage}%
    </Label>
  ) : (
    <Label size="small">N/A</Label>
  );
};

const HardwareTable = ({ products, isLoading, onEdit, onDelete }) => {
  const renderTableContent = () => {
    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="8">
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (products.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="8" style={{ textAlign: 'center' }}>
            No data
          </Table.Cell>
        </Table.Row>
      );
    }

    return products.map(product => (
      <Table.Row key={product.id}>
        <Table.Cell>{product.name}</Table.Cell>
        <Table.Cell>{product.sku}</Table.Cell>
        <Table.Cell>{formatCurrencyRupiah(product.price_per_unit)}</Table.Cell>
        <Table.Cell>{getDiscountLabel(product)}</Table.Cell>
        <Table.Cell>{getStockLabel(product)}</Table.Cell>
        <Table.Cell>
          {product.updated_at
            ? format(new Date(product.updated_at), 'yyyy-MM-dd HH:mm:ss')
            : '-'}
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Icon
            name="pencil"
            link
            color="blue"
            onClick={() => onEdit(product)}
            style={{ marginRight: '1em', cursor: 'pointer' }}
          />
          <Icon
            name="trash"
            link
            color="red"
            onClick={() => onDelete(product)}
            style={{ cursor: 'pointer' }}
          />
        </Table.Cell>
      </Table.Row>
    ));
  };

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Type</Table.HeaderCell>
          <Table.HeaderCell>SKU</Table.HeaderCell>
          <Table.HeaderCell>Price</Table.HeaderCell>
          <Table.HeaderCell>Discount</Table.HeaderCell>
          <Table.HeaderCell>Stock Status</Table.HeaderCell>
          <Table.HeaderCell>Updated</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" width={2}>
            Actions
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{renderTableContent()}</Table.Body>
    </Table>
  );
};

HardwareTable.propTypes = {
  products: PropTypes.array,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

HardwareTable.defaultProps = {
  products: [],
  isLoading: false,
};

export default HardwareTable;
